var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenCarbonNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "127px",
    viewBox: "0 0 124 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Token-CarbonNeutral") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 62,
    cy: 62,
    r: 62
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-1.2%",
    width: "102.4%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "11.18 21.16 2.84 12.82 0 15.64 11.18 26.82 35.18 2.82 32.36 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\"ESG\"-Game-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ESG/S/Q1-b/Q2-b/Q3",
    transform: "translate(-54.000000, -243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(24.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(0.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Token-CarbonNeutral",
    transform: "translate(30.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_favorite",
    mask: "url(#mask-2)",
    fill: "#575F69"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.500000, 9.166667)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.65,0 C50.7126102,0 54.8166667,4.10405646 54.8166667,9.16666667 C54.8166667,14.2292769 50.7126102,18.3333333 45.65,18.3333333 C40.5873898,18.3333333 36.4833333,14.2292769 36.4833333,9.16666667 C36.4833333,4.10405646 40.5873898,0 45.65,0 M27.5,4.58333333 C31.2969577,4.58333333 34.375,7.66137568 34.375,11.4583333 C34.375,15.255291 31.2969577,18.3333333 27.5,18.3333333 C23.7030423,18.3333333 20.625,15.255291 20.625,11.4583333 C20.625,7.66137568 23.7030423,4.58333333 27.5,4.58333333 M13.9791667,11.4583333 C16.5104718,11.4583333 18.5625,13.5103616 18.5625,16.0416667 C18.5625,18.5729718 16.5104718,20.625 13.9791667,20.625 C11.4478616,20.625 9.39583333,18.5729718 9.39583333,16.0416667 C9.39583333,13.5103616 11.4478616,11.4583333 13.9791667,11.4583333 M4.58333333,18.3333333 C7.11463844,18.3333333 9.16666667,20.3853616 9.16666667,22.9166667 C9.16666667,25.4479718 7.11463844,27.5 4.58333333,27.5 C2.05202823,27.5 0,25.4479718 0,22.9166667 C0,20.3853616 2.05202823,18.3333333 4.58333333,18.3333333 M38.9125,45.8333333 C42.1456836,45.8120746 45.2194033,44.4258354 47.3755753,42.0165097 C49.5317472,39.607184 50.5696616,36.3990465 50.2333333,33.1833333 C49.40237,27.2357678 44.2756228,22.8358008 38.2708333,22.9166667 L26.9041667,22.9166667 C14.5282379,22.9016797 3.66690769,31.1555403 0.366666667,43.0833333 C-0.246405783,45.2128502 -0.0673011529,47.4923637 0.870833333,49.5 C2.919238,53.7294219 3.98469851,58.3673089 3.9875,63.0666667 C3.84395592,67.5040843 2.7663483,71.8613673 0.825,75.8541667 C-0.36648476,78.4437399 -0.229835113,81.4500322 1.19166667,83.9208333 C4.95926558,89.9214227 12.1215977,92.8673691 19.0208333,91.2541667 C24.0851433,90.0830379 28.2680903,86.530685 30.2440059,81.7229271 C32.2199215,76.9151693 31.7438492,71.44803 28.9666667,67.0541667 C27.5311433,64.8334966 26.8112711,62.2259596 26.9041667,59.5833333 C26.9041667,59.5833333 25.85,45.8333333 38.9125,45.8333333 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ic_favorite",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.354839, 39.327957)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3655914,-7.10542736e-15 C1.05911134,-7.10542736e-15 0,1.05911134 0,2.3655914 L0,9.46236559 C0,10.7688456 1.05911134,11.827957 2.3655914,11.827957 L5.91397849,11.827957 L5.91397849,9.46236559 L2.3655914,9.46236559 L2.3655914,2.3655914 L5.91397849,2.3655914 L5.91397849,-7.10542736e-15 L2.3655914,-7.10542736e-15 M9.46236559,-7.10542736e-15 C8.15588554,-7.10542736e-15 7.09677419,1.05911134 7.09677419,2.3655914 L7.09677419,9.46236559 C7.09677419,10.7688456 8.15588554,11.827957 9.46236559,11.827957 L11.827957,11.827957 C13.134437,11.827957 14.1935484,10.7688456 14.1935484,9.46236559 L14.1935484,2.3655914 C14.1935484,1.05911134 13.134437,-7.10542736e-15 11.827957,-7.10542736e-15 L9.46236559,-7.10542736e-15 M9.46236559,2.3655914 L11.827957,2.3655914 L11.827957,9.46236559 L9.46236559,9.46236559 L9.46236559,2.3655914 M15.3763441,4.13978495 L15.3763441,5.91397849 L18.9247312,5.91397849 L18.9247312,7.68817204 L17.1505376,7.68817204 C16.1706776,7.68817204 15.3763441,8.48250555 15.3763441,9.46236559 L15.3763441,13.0107527 L20.6989247,13.0107527 L20.6989247,11.2365591 L17.1505376,11.2365591 L17.1505376,9.46236559 L18.9247312,9.46236559 C19.9045912,9.46236559 20.6989247,8.66803208 20.6989247,7.68817204 L20.6989247,5.91397849 C20.6989247,4.93411845 19.9045912,4.13978495 18.9247312,4.13978495 L15.3763441,4.13978495 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ic_favorite",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.820000, 73.180000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#4BD5AD",
    fillRule: "nonzero",
    xlinkHref: "#path-4"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenCarbonNeutral);
export default __webpack_public_path__ + "static/media/Token-CarbonNeutral.9ea3ae846f8a5846f69b3b319bd3e259.svg";
export { ForwardRef as ReactComponent };